import { css } from 'react-emotion';

const breakpoints = {
   mobile: 414,
   tablet: 600,
   desktop: 1024
};

const media = Object.freeze(
   Object.keys(breakpoints).reduce((acc, label) => {
      acc[label] = {
         breakpoint: `(max-width: ${breakpoints[label]}px)`,
         style: cls => css`
            @media ${acc[label].breakpoint} {
               ${cls};
            }
         `
      };
      return acc;
   }, {})
);

export default media;



// WEBPACK FOOTER //
// ./src/UI/mixins/mediaQueries.js